export default {
	name: 'Convention.Schedule.Browse',
	path: 'convention/schedule',
	topLevel: true,
	collection: true,
	meta: {
		auth: false
	}
}